const getPreviousOffset = (
    currentOffset: number,
    limit: number
): number | null => {
    const previousOffset = currentOffset - Math.abs(limit);
    return previousOffset < 1 ? null : previousOffset;
};

export default getPreviousOffset;
